import FeatureFlagService from 'src/services/FeatureFlagService';
import {isPlatform} from '@ionic/react';
import {Platforms} from '@ionic/core';
import {Capacitor} from '@capacitor/core';

export enum AppPlatform {
  BASIC = 'BASIC',
  IONIC = 'IONIC',
}

/**
 * Stores latest platform in local storage
 */
export default class PlatformService {
  private _canViewIonic: boolean | undefined;
  private _localStorageKey = 'lastViewedPlatform';

  async canViewIonic(): Promise<boolean> {
    if (Capacitor.getPlatform() !== 'web') {
      this._canViewIonic = true;
      return this._canViewIonic;
    }

    if (!this._canViewIonic) {
      this._canViewIonic = await FeatureFlagService.getFeatureFlagStatus('canViewIonicApplication');
    }

    return this._canViewIonic;
  }

  private getStoredPlatform(): AppPlatform | null {
    const storageValue = window.localStorage.getItem(this._localStorageKey) as AppPlatform;
    if ([AppPlatform.BASIC, AppPlatform.IONIC].includes(storageValue)) {
      return storageValue;
    }

    return null;
  }

  async setPlatform(p: AppPlatform): Promise<AppPlatform> {
    if (await this.canViewIonic()) {
      window.localStorage.setItem(this._localStorageKey, p);
    }

    return this.getPlatform();
  }

  async getPlatform(): Promise<AppPlatform> {
    return (await this.getStoredPlatform()) || AppPlatform.BASIC;
  }

  public static isIonicPlatform(platform: Platforms): boolean {
    return isPlatform(platform);
  }

  public static isIonicMobilePlatform(): boolean {
    return isPlatform('mobile');
  }
}
